<template>
    <div class="create-role">
        <div class="content-header">
            <div>
                <h2 class="content-title card-title">Add Role</h2>
            </div>
        </div>
        <a-card>
            <a-form :form="form"  @submit="handleSubmit">
                <a-row :gutter="20">
                    <a-col class="gutter-row" :span="12">
                        <a-form-item label="Name">
                            <a-input size="large"
                                v-decorator="['name', { rules: [{ required: true, message: 'Please enter name' }] }]"
                                placeholder="Enter name"
                            />
                        </a-form-item>

                        <a-form-item class="mb-1">
                            <a-checkbox :checked="isHubdep" @change="updateHubDep"
                                v-decorator="['hub_dependent', { rules: [{ required: false }] }]">
                                Hub Depended
                            </a-checkbox>
                        </a-form-item>
                        <a-form-item class="mb-1">
                            <a-checkbox :checked="isDivisionDep" @change="updateDivisionDep"
                                v-decorator="['division_dependent', { rules: [{ required: false }] }]">
                                Division Depended
                            </a-checkbox>
                        </a-form-item>
                        <a-form-item>
                            <a-checkbox :checked="isAreaDep" @change="updateAreaDep"
                                v-decorator="['area_dependent', { rules: [{ required: false }] }]">
                                Area Depended
                            </a-checkbox>
                        </a-form-item>
                    </a-col>
                    <a-col class="gutter-row" :span="12">
                        <div>
                            <a-form-item label="Permissions">
                                <a-checkbox-group v-decorator="[
                                    'permissions',
                                    { rules: [{ required: true, message: 'Please select Permissions!' }] }
                                    ]">
                                    <a-row class="permissions-allow-list">
                                        <template v-for="item in permissions">
                                            <a-col :span="24" :key="item.id">
                                                <a-checkbox :value="item.id">
                                                    {{item.name}}
                                                </a-checkbox>
                                            </a-col>
                                        </template>
                                    </a-row>
                                </a-checkbox-group>
                            </a-form-item>
                        </div>
                    </a-col>
                </a-row>

                <a-form-item >
                    <a-button type="primary" size="large" class="btn btn-xs" html-type="submit">
                        Create Role
                    </a-button>
                </a-form-item>
            </a-form>
        </a-card>
    </div>
</template>
<script>
    import { GET_PERMISSIONS, CREATE_ROLE } from "../../../script/api";
    import { getData, postData } from "../../../script/api-service";
    import {alertPop} from "../../../script/helper";

    export default {
        data() {
            return {
                permissions: [],
                isHubdep: false,
                isDivisionDep: false,
                isAreaDep: false
            };
        },
        methods: {
            async getPermissions() {
                let res = await getData(GET_PERMISSIONS);

                if (res) {
                    let masterData = res.data?.data;
                    if (masterData?.length) this.permissions = masterData;
                }
            },

            handleSubmit(e) {
                e.preventDefault();

                this.form.validateFields(async (err, values) => {
                    if (!err) {
                        values.guard_name = "web";
                        values.hub_dependent = values.hub_dependent ? 1 : 0;
                        values.division_dependent = values.division_dependent ? 1 : 0;
                        values.area_dependent = values.area_dependent ? 1 : 0;

                        let res = await postData(CREATE_ROLE, values);

                        if (res) {
                            alertPop("success", "Role Created Successfully");
                            this.form.resetFields();
                            this.isHubdep = false;
                            this.isDivisionDep = false;
                            this.$router.push({ path: '/manage-role' });
                        }
                    }
                });
            },
            updateHubDep(e) {
                this.isHubdep = e.target.checked;
            },
            updateDivisionDep(e) {
                this.isDivisionDep = e.target.checked;
            },
            updateAreaDep(e) {
                this.isAreaDep = e.target.checked;
            }
        },
        beforeCreate() {
            this.form = this.$form.createForm(this, { name: "create_role" });
        },
        mounted() {
            this.getPermissions();
        },
    }           
</script>